/**
 * @voltxampere/ui — 74HC04 hex NOT CMOS variant (Sprint 42-1)
 *
 * Reference: TI SN74HC04. CMOS sibling of the Sprint 41-4 7404.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const logic74hc04 = {
    id: "74hc04",
    nameTr: "74HC04 (6'lı NOT CMOS, DIP-14)",
    nameEn: "74HC04 (Hex Inverter CMOS, DIP-14)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "74HC04",
    schemaType: "digital-gate",
    defaultParams: {
        gateFunction: "NOT",
        vHigh: 5,
        vLow: 0,
        threshold: 2.5,
        propagationDelay: 8e-9,
    },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=logic-74hc04.js.map